import { ProtectedRoute, portal, bbbeeScorecardRoute } from '../Component/Common/Constants/routes';
import { LegacyBEEPage } from '../Component/Common/Components/LegacyBEEPage/LegacyBEEPage';

export interface TabConfig {
    label: string;
    route: string;
    iframeRoute: string;
}

export const legacyRouteMap: Record<string, string> = {
    'General Information': 'general',
    'Ownership': 'ownership',
    'Management Control': 'managementControl',
    'Skills Development': 'skillsdevelopment',
    'Enterprise Development': 'enterpriseDevelopment',
    'Supplier Development': 'supplierDevelopment',
    'Socio-Economic Development': 'socioEconomicDevelopment',
    'Preferential Procurement': 'preferentialProcurement',
    'Economic Development': 'economicDevelopment',
    'Employment Equity': 'employmentEquity',
    'Empowerment Financing': 'empowermentFinancing',
    'Access to Financial Services': 'accessToFinancialServices',
    'Responsible Social Media': 'rsm',
    'Localisation': 'localisation',
};

export const elementIcons: Record<string, string> = {
    'General Information': 'nc-icon nc-single-copy-04',
    'Ownership': 'nc-icon nc-money-coins',
    'Management Control': 'nc-icon nc-badge',
    'Skills Development': 'nc-icon nc-hat-3',
    'Enterprise Development': 'nc-icon nc-shop',
    'Supplier Development': 'nc-icon nc-shop',
    'Socio-Economic Development': 'nc-icon nc-world-2',
    'Preferential Procurement': 'nc-icon nc-cart-simple',
    'Economic Development': 'nc-icon nc-bank',
    'Employment Equity': 'nc-icon nc-single-02',
    'Empowerment Financing': 'nc-icon nc-credit-card',
    'Access to Financial Services': 'nc-icon nc-bank',
    'Responsible Social Media': 'nc-icon nc-chat-33',
    'Localisation': 'nc-icon nc-pin-3',
};

export const elementToDocumentsTab: Record<string, TabConfig> = {
    'General Information': { label: 'General', route: 'general', iframeRoute: 'supportingDocuments/{ScorecardId}/General' },
    'Ownership': { label: 'Ownership', route: 'ownership', iframeRoute: 'supportingDocuments/{ScorecardId}/ownership' },
    'Management Control': { label: 'Management', route: 'management', iframeRoute: 'supportingDocuments/{ScorecardId}/management' },
    'Skills Development': { label: 'Skills Dev', route: 'skillsDevelopment', iframeRoute: 'supportingDocuments/{ScorecardId}/skillsDevelopment' },
    'Preferential Procurement': { label: 'Procurement', route: 'procurement', iframeRoute: 'supportingDocuments/{ScorecardId}/PreferentialProcurement' },
    'Supplier Development': { label: 'Supplier Dev', route: 'supplierDevelopment', iframeRoute: 'supportingDocuments/{ScorecardId}/supplierDevelopmentDetail' },
    'Enterprise Development': { label: 'Enterprise Dev', route: 'enterpriseDevelopment', iframeRoute: 'supportingDocuments/{ScorecardId}/ed' },
    'Socio-Economic Development': { label: 'SED', route: 'sed', iframeRoute: 'supportingDocuments/{ScorecardId}/sed' },
    'Responsible Social Media': { label: 'RSM', route: 'rsm', iframeRoute: 'supportingDocuments/{ScorecardId}/rsm' },
    'Empowering Supplier': { label: 'Empowering Supplier', route: 'empoweringSupplier', iframeRoute: 'supportingDocuments/{ScorecardId}/EmpoweringSupplier' },
    'Y.E.S. Initiative': { label: 'Y.E.S. Initiative', route: 'yesInitiative', iframeRoute: 'supportingDocuments/{ScorecardId}/yesInitiative' },
    'Empowerment Financing': { label: 'Empowerment Financing', route: 'empowermentFinancing', iframeRoute: 'supportingDocuments/{ScorecardId}/EmpowermentFinancing' },
    'Economic Development': { label: 'Economic Development', route: 'economicDevelopment', iframeRoute: 'supportingDocuments/{ScorecardId}/EconomicDevelopment' },
    'Access to Financial Services': { label: 'AFS', route: 'afs', iframeRoute: 'supportingDocuments/{ScorecardId}/AccessToFinancialServices' },
};

export const reportingTabs: TabConfig[] = [
    { label: 'Scorecard Report', route: 'scorecardReport', iframeRoute: 'reporting/{ScorecardId}/scorecardReport' },
    { label: 'Statutory Report', route: 'statutoryReport', iframeRoute: 'reporting/{ScorecardId}/statutoryReport' },
    { label: 'Dashboard Powerpoint', route: 'dashboardPowerpoint', iframeRoute: 'reporting/{ScorecardId}/DashboardPowerPoint' },
];

export const getFixedTopRoutes = (): ProtectedRoute[] => [
    {
        name: 'Summary',
        icon: 'nc-icon nc-chart-pie-36',
        layout: portal,
        isExternal: false,
        collapse: true,
        state: 'SummaryCollapse',
        views: [
            {
                path: `${bbbeeScorecardRoute}summary/dashboard`,
                name: 'Dashboard',
                mini: 'DB',
                Component: LegacyBEEPage,
                componentProps: {
                    legacyRoute: 'scorecard/{ScorecardId}/dashboard',
                    elementName: 'Summary',
                    pageTitle: 'Dashboard'
                },
                layout: portal,
            },
            {
                path: `${bbbeeScorecardRoute}summary/scorecard`,
                name: 'Scorecard',
                mini: 'SC',
                Component: LegacyBEEPage,
                componentProps: {
                    legacyRoute: 'scorecard/{ScorecardId}/summary',
                    elementName: 'Summary',
                    pageTitle: 'Scorecard'
                },
                layout: portal,
            },
            {
                path: `${bbbeeScorecardRoute}summary/notes`,
                name: 'Notes',
                mini: 'NT',
                Component: LegacyBEEPage,
                componentProps: {
                    legacyRoute: 'notes/{ScorecardId}',
                    elementName: 'Summary',
                    pageTitle: 'Notes'
                },
                layout: portal,
            },
        ],
    },
];

export const getFixedBottomRoutes = (elementNames: string[]): ProtectedRoute[] => {
    const downloadPackTab: TabConfig = { label: 'Download Pack', route: 'pack', iframeRoute: 'supportingDocuments/{ScorecardId}/pack' };
    const elementDocumentsTabs = elementNames
        .filter(name => elementToDocumentsTab[name])
        .map(name => elementToDocumentsTab[name]);
    const documentsTabs = [downloadPackTab, ...elementDocumentsTabs];

    return [
        {
            path: `${bbbeeScorecardRoute}importTemplates`,
            name: 'Import Templates',
            icon: 'nc-icon nc-cloud-download-93',
            Component: LegacyBEEPage,
            componentProps: {
                legacyRoute: 'importTemplates/{ScorecardId}',
                elementName: '',
                pageTitle: 'Download Import Templates & Instructions'
            },
            layout: portal,
            isExternal: false,
        },
        {
            path: `${bbbeeScorecardRoute}verification/documents`,
            name: 'Verification',
            icon: 'nc-icon nc-check-2',
            Component: LegacyBEEPage,
            componentProps: {
                legacyRoute: 'supportingDocuments/{ScorecardId}/pack',
                basePath: `${portal}${bbbeeScorecardRoute}verification/documents`,
                tabs: documentsTabs,
                elementName: 'Verification',
                pageTitle: 'Supporting Documents'
            },
            layout: portal,
            isExternal: false,
        },
        {
            path: `${bbbeeScorecardRoute}reporting`,
            name: 'Reporting',
            icon: 'nc-icon nc-single-copy-04',
            Component: LegacyBEEPage,
            componentProps: {
                legacyRoute: 'reporting/{ScorecardId}/scorecardReport',
                basePath: `${portal}${bbbeeScorecardRoute}reporting`,
                tabs: reportingTabs,
                pageTitle: 'Reporting'
            },
            layout: portal,
            isExternal: false,
        },
    ];
};
